import Button from '@oncolens/oncolens-ui/lib/components/FormControls/Button';
import React, { useState } from 'react';
import { BsPlusCircle } from 'react-icons/bs';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useNavigate } from 'react-router';
import GuidelineTemplateTable from './GuidelineTemplateTable';
import TableSearch from './TableSearch';

export default function TemplatesList() {
  const [queryValue, setQueryValue] = useState('');
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex items-center my-3">
        <TableSearch
          className="ml-auto"
          setQuery={setQueryValue}
          testSelector="templates-list-search"
        />
        <Button
          onClick={() => navigate('template/add')}
          buttonColor="blue"
          className="flex items-center w-auto py-1.5 ml-2"
          testSelector="add-guideline-template">
          <BsPlusCircle className="mr-2" /> Create Template
        </Button>
      </div>
      <GuidelineTemplateTable searchQuery={queryValue} />
    </div>
  );
}
